var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCampaignDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2831_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 7.76628H23.3337M11.667 12.4329V19.4329M16.3337 12.4329V19.4329M5.83366 7.76628L7.00033 21.7663C7.00033 22.3851 7.24616 22.9786 7.68374 23.4162C8.12133 23.8538 8.71482 24.0996 9.33366 24.0996H18.667C19.2858 24.0996 19.8793 23.8538 20.3169 23.4162C20.7545 22.9786 21.0003 22.3851 21.0003 21.7663L22.167 7.76628M10.5003 7.76628V4.26628C10.5003 3.95686 10.6232 3.66011 10.842 3.44132C11.0608 3.22253 11.3576 3.09961 11.667 3.09961H16.3337C16.6431 3.09961 16.9398 3.22253 17.1586 3.44132C17.3774 3.66011 17.5003 3.95686 17.5003 4.26628V7.76628",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2831_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignDeleteIcon);
export default __webpack_public_path__ + "static/media/campaignDeleteIcon.c338afdf18504307019035a73e802535.svg";
export { ForwardRef as ReactComponent };